import { IExerciseSelectionFilter } from '../../logic/workoutselection';
import { Exercise } from '../exercise';
import { UserExerciseSession } from '../workoutsession';

export interface IFilterNameAndCount {
    name: string;
    count: number;
    exerciseReference?: string[];
}

export class ExerciseAnalysisForZoneAndStage {
    public filters: IFilterNameAndCount[] = [];
    public filterErrors: string[] = [];
    public finalExercisesInDisplayableFormat: string[] = [];
    public selectedExerciseSession: UserExerciseSession;
    constructor(
        public stage: number,
        public zone: number,
    ) { }

    public addToFilterProgression(filterNameAndCount: IFilterNameAndCount, exercises: Exercise[]) {
        if (this.findFilter(filterNameAndCount.name)) {
            throw new Error('That filter already exists in this stage');
        }
        this.mapExerciseReferencesToFilterNameCount(filterNameAndCount, exercises);
        this.filters.push(filterNameAndCount);
    }

    public addFilterError(filter: IExerciseSelectionFilter) {
        this.filterErrors.push(filter.name);
    }

    public setFinaleExercises(exercises: Exercise[]) {
        this.finalExercisesInDisplayableFormat = exercises.map((e: Exercise) =>
            `${e.uniqueReferenceNumber} - ${e.name} - ${e.exerciseFormats.join(' · ')}`,
        );
    }

    public stageZoneCountToCsv(): string {
        return `${this.zone},${this.stage},${this.filterCountToCsv()},${this.filterErrorToCsv()},` +
            `${this.selectedExerciseToCsv()},${this.finalExercisesString()}`;
    }

    public filterCountToCsv(): string {
        let csvString = '';
        this.filters.forEach((filter: IFilterNameAndCount, index: number) => {
            csvString += `${filter.count}${index === (this.filters.length - 1) ? '' : ','}`;
        });
        return csvString;
    }

    public csvHeader(): string {
        return `Zone,Stage,${this.filterNameToCsv()},FilterError,` +
            `FinalFormat,FinalPrimaryNr,FinalSecondaryNr,FinalPrimaryName,FinalSecondaryName,FinalExercises`;
    }

    public filterNameToCsv(): string {
        let csvString = '';
        this.filters.forEach((filter: IFilterNameAndCount, index: number) => {
            csvString += `${filter.name}${index === (this.filters.length - 1) ? '' : ','}`;
        });
        return csvString;
    }

    public mapExerciseReferencesToFilterNameCount(filterNameCount: IFilterNameAndCount, exercises: Exercise[]) {
        filterNameCount.exerciseReference = exercises.map((e: Exercise) => e.uniqueReferenceNumber);
    }

    private finalExercisesString(): string {
        return this.finalExercisesInDisplayableFormat.join('; ');
    }

    private filterErrorToCsv(): string {
        return this.filterErrors.join(' · ');
    }

    private selectedExerciseToCsv(): string {
        const se = this.selectedExerciseSession.exercise;
        const alt = this.selectedExerciseSession.alternateExercise;
        return `${this.selectedExerciseSession.format},` +
            `${se.uniqueReferenceNumber},` + `${alt ? alt.uniqueReferenceNumber : ''},` + `${se.name},` +
            `${alt ? `${alt.name}` : ''}`;
    }

    private findFilter(name: string): IFilterNameAndCount | undefined {
        return this.filters.find((filter: IFilterNameAndCount) => filter.name === name);
    }
}
